import React from 'react';
import { ButtonSize } from '@wix/wix-ui-tpa/cssVars';
import { useEnvironment } from '@wix/yoshi-flow-editor';

import { Replace as ReplaceIcon } from '@wix/wix-ui-icons-common/on-stage';

import { Show } from '../Show';
import { Button } from '../Button';
import { EmptyState, type IEmptyStateProps } from '../EmptyState';

export interface IErrorStateProps extends IEmptyStateProps {
  buttonProps?: React.ComponentProps<typeof Button>;
  actionLabel?: string;

  onRetry?(): void;
}

export function ErrorState(props: IErrorStateProps) {
  const { onRetry, actionLabel, buttonProps, ...rest } = props;

  const { isMobile } = useEnvironment();

  return (
    <EmptyState
      action={
        <Show if={!!onRetry}>
          <Button
            onClick={onRetry}
            prefixIcon={<ReplaceIcon />}
            size={isMobile ? ButtonSize.small : undefined}
            {...buttonProps}
          >
            {actionLabel}
          </Button>
        </Show>
      }
      {...rest}
    />
  );
}

ErrorState.displayName = 'wui/ErrorState';
